<div class="icon-row">
  @if (icon || svgIcon) {
    <div class="icon">
      @if (icon) {
        <i class="material-icons">{{ icon }}</i>
      }
      @if (svgIcon) {
        <mat-icon [svgIcon]="svgIcon"></mat-icon>
      }
    </div>
  }
  <div class="info">
    <div class="info-title fw flex items-center g-2">
      {{ title }}
      @if (showBadge) {
        <app-badge
          class="inline-block"
          [identityVerificationStatus]="false"
          [workspaces]="workspaces"
          [hideUnverifiedBadge]="true"
          [size]="22"
          [showTooltip]="false"
        ></app-badge>
      }
    </div>
    @if (subtitles) {
      <div>
        @for (subtitle of subtitles; track subtitle) {
          <div>
            <div class="info-subtitle">{{ subtitle }}</div>
          </div>
        }
      </div>
    }
  </div>
</div>
